module.exports = __webpack_public_path__ + "static/media/MOBI.3f515b60.svg";